import { tagColors } from "@/components/tag/tag-colors";
export const AdTypeEnum = {
  SP: 0,
  SD: 1,
  SB: 2,
};

export const AdStrategyStatusEnum = {
  OPEN: 0,
  CLOSE: 1,
  NO_ADD: 2,

  option: [
    {id: 0, text: '已开启'},
    {id: 1, text: '已关闭'},
    {id: 2, text: '未添加'},
  ],
};

const AdStatus = {
  ENABLE: 0,
  PAUSE: 1,
  ARCHIVE: 2,
  ENABLE_PAUSE: 4
};

const AdStatusOption = [
  {id: 0, text: '进行中'},
  {id: 1, text: '暂停中'},
  {id: 4, text: '进行/暂停'},
  {id: 2, text: '已归档'}
];

const negStatus = {
  ENABLE: 0,
  ARCHIVE: 2,
};

const negStatusOption = [
  {id: 0, text: '启用'},
  {id: 2, text: '已归档'},
];

export const AdCampaignEnum = {
  SP: {
    targetingType: {
      AUTO: 1,
      MANUAL: 0
    },
    targetingTypeOption: [
      {id: 1, text: '自动投放', color: '#34bfa3'},
      {id: 0, text: '手动投放', color: '#5986fb'},
    ],
    status: AdStatus,
    statusOption: AdStatusOption,
    bidStrategyOption: [
      {id: 0, text: '动态竞价-只降低'},
      {id: 1, text: '动态竞价-提高和降低'},
      {id: 2, text: '固定竞价'},
    ],
    outOfBudgetOption: [
      {id: 'CAMPAIGN_OUT_OF_BUDGET', text: '是'},
      {id: 'OTHER', text: '否'},
    ],
    servingStatusOption: [
      {id: 'CAMPAIGN_ARCHIVED', text: '已归档'},
      {id: 'CAMPAIGN_PAUSED', text: '已暂停'},
      {id: 'CAMPAIGN_STATUS_ENABLED', text: '正在投放'},
      {id: 'CAMPAIGN_INCOMPLETE', text: '正在投放'},
      {id: 'ADVERTISER_PAYMENT_FAILURE', text: '广告商支付失败'},
      {id: 'CAMPAIGN_OUT_OF_BUDGET', text: '超出预算'},
      {id: 'ACCOUNT_OUT_OF_BUDGET', text: '预算外的账户'},
      {id: 'ASIN_NOT_BUYABLE', text: 'ASIN无法购买'},
      {id: 'BILLING_ERROR', text: '帐单信息错误'},
      {id: 'OUTOFBUDGET', text: '超出预算'},
      {id: 'ENDED', text: '已结束'},
      {id: 'LANDINGPAGENOTAVAILABLE', text: '登录页面不可用'},
      {id: 'OUT_OF_BUDGET', text: '超出预算'},
      {id: 'PAUSED', text: '已暂停'},
      {id: 'PENDING_REVIEW', text: '等待审核'},
      {id: 'READY', text: '准备中'},
      {id: 'REJECTED', text: '审核失败'},
      {id: 'RUNNING', text: '正在运行'},
      {id: 'SCHEDULED', text: '等待运行'},
      {id: 'TERMINATED', text: '已终止'}
    ]
  },
  SB: {
    targetingType: {
      AUTO: 1,
      MANUAL: 0
    },
    targetingTypeOption: [
      {id: 1, text: '自动投放', color: '#34bfa3'},
      {id: 0, text: '手动投放', color: '#5986fb'},
    ],
    status: AdStatus,
    statusOption: AdStatusOption,
    bidStrategyOption: [
      {id: 0, text: '动态竞价-只降低'},
      {id: 1, text: '动态竞价-提高和降低'},
      {id: 2, text: '固定竞价'},
    ],
    outOfBudgetOption: [
      {id: 'CAMPAIGN_OUT_OF_BUDGET', text: '是'},
      {id: 'OTHER', text: '否'},
    ],
    servingStatusOption: [
      {id: 'CAMPAIGN_ARCHIVED', text: '已归档'},
      {id: 'CAMPAIGN_PAUSED', text: '已暂停'},
      {id: 'CAMPAIGN_STATUS_ENABLED', text: '正在投放'},
      {id: 'CAMPAIGN_INCOMPLETE', text: '正在投放'},
      {id: 'ADVERTISER_PAYMENT_FAILURE', text: '广告商支付失败'},
      {id: 'CAMPAIGN_OUT_OF_BUDGET', text: '超出预算'},
      {id: 'ACCOUNT_OUT_OF_BUDGET', text: '预算外的账户'},
      {id: 'ASIN_NOT_BUYABLE', text: 'ASIN无法购买'},
      {id: 'BILLING_ERROR', text: '帐单信息错误'},
      {id: 'OUTOFBUDGET', text: '超出预算'},
      {id: 'ENDED', text: '已结束'},
      {id: 'LANDINGPAGENOTAVAILABLE', text: '登录页面不可用'},
      {id: 'OUT_OF_BUDGET', text: '超出预算'},
      {id: 'PAUSED', text: '已暂停'},
      {id: 'PENDING_REVIEW', text: '等待审核'},
      {id: 'READY', text: '准备中'},
      {id: 'REJECTED', text: '审核失败'},
      {id: 'RUNNING', text: '正在运行'},
      {id: 'SCHEDULED', text: '等待运行'},
      {id: 'TERMINATED', text: '已终止'},
      {id: 'OTHER', text: '其他'}
    ]
  },
  SD: {
    status: AdStatus,
    statusOption: AdStatusOption,
    targetingType: {
      AUDIENCES: 'T00030',
      PRODUCT_TARGETING: 'T00020'
    },
    targetingTypeOption: [
      {id: 'T00020', text: '商品投放'},
      {id: 'T00030', text: '受众'},
      {id: 'remarketing', text: '再营销'},
    ],
    bidStrategyOption: [
      {id: 0, text: '动态竞价-只降低'},
      {id: 1, text: '动态竞价-提高和降低'},
      {id: 2, text: '固定竞价'},
    ],
    outOfBudgetOption: [
      {id: 'CAMPAIGN_OUT_OF_BUDGET', text: '是'},
      {id: 'OTHER', text: '否'},
    ],
    servingStatusOption: [
      {id: 'CAMPAIGN_ARCHIVED', text: '已归档'},
      {id: 'CAMPAIGN_PAUSED', text: '已暂停'},
      {id: 'CAMPAIGN_STATUS_ENABLED', text: '正在投放'},
      {id: 'CAMPAIGN_INCOMPLETE', text: '正在投放'},
      {id: 'ADVERTISER_PAYMENT_FAILURE', text: '广告商支付失败'},
      {id: 'CAMPAIGN_OUT_OF_BUDGET', text: '超出预算'},
      {id: 'ACCOUNT_OUT_OF_BUDGET', text: '预算外的账户'},
      {id: 'ASIN_NOT_BUYABLE', text: 'ASIN无法购买'},
      {id: 'BILLING_ERROR', text: '帐单信息错误'},
      {id: 'OUTOFBUDGET', text: '超出预算'},
      {id: 'ENDED', text: '已结束'},
      {id: 'LANDINGPAGENOTAVAILABLE', text: '登录页面不可用'},
      {id: 'OUT_OF_BUDGET', text: '超出预算'},
      {id: 'PAUSED', text: '已暂停'},
      {id: 'PENDING_REVIEW', text: '等待审核'},
      {id: 'READY', text: '准备中'},
      {id: 'REJECTED', text: '审核失败'},
      {id: 'RUNNING', text: '正在运行'},
      {id: 'SCHEDULED', text: '等待运行'},
      {id: 'TERMINATED', text: '已终止'}
    ]
  }
};

export const AdGroupEnum = {
  SP: {
    servingStatusOption: [
      {id: 'AD_GROUP_ARCHIVED', text: '已归档'},
      {id: 'AD_GROUP_PAUSED', text: '已暂停'},
      {id: 'AD_GROUP_STATUS_ENABLED', text: '正在投放'},
      {id: 'CAMPAIGN_PAUSED', text: '广告活动已暂停'},
      {id: 'CAMPAIGN_STATUS_ENABLED', text: '正在投放'},
      {id: 'CAMPAIGN_OUT_OF_BUDGET', text: '广告活动超出预算'},
      {id: 'PENDING_START_DATE', text: '广告活动未开始'},
      {id: 'CAMPAIGN_ARCHIVED', text: '广告活动已归档'},
      {id: 'CAMPAIGN_INCOMPLETE', text: '广告活动未完成'},
      {id: 'ACCOUNT_OUT_OF_BUDGET', text: '预算外的帐户'},
      {id: 'ASIN_NOT_BUYABLE', text: 'ASIN无法购买'},
      {id: 'BILLING_ERROR', text: '帐单信息错误'},
      {id: 'OUTOFBUDGET', text: '超出预算'},
      {id: 'ENDED', text: '已结束'},
      {id: 'LANDING_PAGE_NOT_AVAILABLE', text: '登录页面不可用'},
      {id: 'OUT_OF_BUDGET', text: '超出预算'},
      {id: 'PAUSED', text: '已暂停'},
      {id: 'PENDING_REVIEW', text: '等待审核'},
      {id: 'READY', text: '准备中'},
      {id: 'REJECTED', text: '审核失败'},
      {id: 'ENABLED', text: '正在投放'},
      {id: 'RUNNING', text: '正在运行'},
      {id: 'SCHEDULED', text: '等待运行'},
      {id: 'TERMINATED', text: '已终止'},
    ],
    status: AdStatus,
    statusOption: AdStatusOption,
    targetingType: {
      KEYWORD: 0,
      PRODUCT: 1,
      AUTO: 2,
      ALL: 99
    },
    targetingTypeOption: [
      {id: 0, text: '关键词投放'},
      {id: 1, text: '商品投放'},
      {id: 2, text: '自动投放'},
    ],
  },
  SD: {
    status: AdStatus,
    statusOption: AdStatusOption,
    targetingType: {
      AUDIENCES: 'remarketing',
      PRODUCT_TARGETING: 'T00020'
    },
    targetingTypeOption: [
      {id: 'remarketing', text: '受众'},
      {id: 'T00020', text: '商品投放'},
    ],
    servingStatusOption: [
      {id: 'AD_GROUP_ARCHIVED', text: '已归档'},
      {id: 'AD_GROUP_PAUSED', text: '已暂停'},
      {id: 'AD_GROUP_STATUS_ENABLED', text: '正在投放'},
      {id: 'CAMPAIGN_PAUSED', text: '广告活动已暂停'},
      {id: 'CAMPAIGN_OUT_OF_BUDGET', text: '广告活动超出预算'},
      {id: 'PENDING_START_DATE', text: '广告活动未开始'},
      {id: 'CAMPAIGN_ARCHIVED', text: '广告活动已归档'},
      {id: 'CAMPAIGN_INCOMPLETE', text: '广告活动未完成'},
      {id: 'ACCOUNT_OUT_OF_BUDGET', text: '预算外的帐户'},
      {id: 'ASIN_NOT_BUYABLE', text: 'ASIN无法购买'},
      {id: 'BILLING_ERROR', text: '帐单信息错误'},
      {id: 'OUTOFBUDGET', text: '超出预算'},
      {id: 'ENDED', text: '已结束'},
      {id: 'LANDING_PAGE_NOT_AVAILABLE', text: '登录页面不可用'},
      {id: 'OUT_OF_BUDGET', text: '超出预算'},
      {id: 'PAUSED', text: '已暂停'},
      {id: 'PENDING_REVIEW', text: '等待审核'},
      {id: 'READY', text: '准备中'},
      {id: 'REJECTED', text: '审核失败'},
      {id: 'ENABLED', text: '正在投放'},
      {id: 'RUNNING', text: '正在运行'},
      {id: 'SCHEDULED', text: '等待运行'},
      {id: 'TERMINATED', text: '已终止'},
    ],
  }
};

export const AdProductEnum = {
  SP: {
    status: AdStatus,
    statusOption: AdStatusOption,
    targetingTypeOption: [
      {id: 0, text: '关键词投放'},
      {id: 1, text: '商品投放'},
      {id: 2, text: '自动投放'},
    ],
    servingStatusOption: [
      {id: 'AD_ARCHIVED', text: '已归档'},
      {id: 'AD_PAUSED', text: '已暂停'},
      {id: 'AD_STATUS_LIVE', text: '正在投放'},
      {id: 'CAMPAIGN_STATUS_ENABLED', text: '正在投放'},
      {id: 'CAMPAIGN_OUT_OF_BUDGET', text: '超出预算'},
      {id: 'AD_GROUP_PAUSED', text: '广告组已暂停'},
      {id: 'AD_GROUP_ARCHIVED', text: '广告组已归档'},
      {id: 'CAMPAIGN_PAUSED', text: '广告活动已暂停'},
      {id: 'CAMPAIGN_ARCHIVED', text: '广告活动已归档'},
      {id: 'ACCOUNT_OUT_OF_BUDGET', text: '预算外的帐户'},
      {id: 'MISSING_DECORATION', text: '不符合条件'},
    ]
  },
  SD: {
    status: AdStatus,
    statusOption: AdStatusOption,
    servingStatusOption: [
      {id: 'AD_ARCHIVED', text: '已归档'},
      {id: 'AD_PAUSED', text: '已暂停'},
      {id: 'AD_STATUS_LIVE', text: '正在投放'},
      {id: 'CAMPAIGN_STATUS_ENABLED', text: '正在投放'},
      {id: 'CAMPAIGN_OUT_OF_BUDGET', text: '超出预算'},
      {id: 'AD_GROUP_PAUSED', text: '广告组已暂停'},
      {id: 'AD_GROUP_ARCHIVED', text: '广告组已归档'},
      {id: 'CAMPAIGN_PAUSED', text: '广告活动已暂停'},
      {id: 'CAMPAIGN_ARCHIVED', text: '广告活动已归档'},
      {id: 'ACCOUNT_OUT_OF_BUDGET', text: '预算外的帐户'},
      {id: 'MISSING_DECORATION', text: '不符合条件'},
    ]
  }
};

export const AdKeywordEnum = {
  SP: {
    status: AdStatus,
    statusOption: AdStatusOption,
    matchType: {
      EXACT: 0,
      PHASE: 1,
      BROAD: 2,
    },
    matchTypeOption: [
      {id: 0, text: '精确匹配', color: '#5986fb'},
      {id: 1, text: '词组匹配', color: '#34bfa3'},
      {id: 2, text: '广泛匹配', color: '#afbacb'},
    ],
    effectivenessTypeOption: [
      {id: 0, text: '普通词'},
      {id: 1, text: '高效词'},
      {id: 2, text: '低效词'}
    ],
    bidType: {
      SUGGEST: 0,
      DEFAULT: 1
    },
    bidTypeOption: [
      {id: 0, text: '建议竞价'},
      {id: 1, text: '默认竞价'}
    ]
  },
  SB: {
    status: AdStatus,
    statusOption: AdStatusOption,
    matchType: {
      EXACT: 0,
      PHASE: 1,
      BROAD: 2,
    },
    matchTypeOption: [
      {id: 0, text: '精确匹配', color: '#5986fb'},
      {id: 1, text: '词组匹配', color: '#34bfa3'},
      {id: 2, text: '广泛匹配', color: '#afbacb'},
    ],
    effectivenessTypeOption: [
      {id: 0, text: '普通词'},
      {id: 1, text: '高效词'},
      {id: 2, text: '低效词'}
    ],
    bidType: {
      SUGGEST: 0,
      DEFAULT: 1
    },
    bidTypeOption: [
      {id: 0, text: '建议竞价'},
      {id: 1, text: '默认竞价'}
    ]
  },
};

export const AdTargetEnum = {
  SP: {
    status: AdStatus,
    statusOption: AdStatusOption,
    targetTypeOption: [
      {id: 'queryHighRelMatches', text: '紧密匹配', help: '我们会向使用与您的产品密切相关的搜索字词的购物者展示您的广告。 如果您的产品是“多普勒400支棉床单”，我们会在购物者使用“棉床单”和“400支床单”等搜索字词时展示广告。'},
      {id: 'queryBroadRelMatches', text: '宽泛匹配', help: '买家使用与您的商品并不密切相关的搜索词进行搜索时，我们会向其显示您的广告。 如果您的商品是“Doppler 400-count Cotton Sheets”，我们将在买家使用“bed sheets”、“bath sheets”和“bath towels”等搜索词时展示广告。'},
      {id: 'asinSubstituteRelated', text: '同类商品', help: '买家查看与您的商品类似的商品的详情页面时，我们会向其展示您的广告。 如果您的商品是“Doppler 400-count Cotton Sheets”，我们将在包含“300-count Cotton Sheets”和“Queen 400-count Sheets”的商品详情页上展示广告。'},
      {id: 'asinAccessoryRelated', text: '关联商品', help: '我们会向查看与您的产品相辅相成的产品详细信息页面的购物者展示您的广告。 如果您的产品是“多普勒400支棉床单”，我们将在包括“大床被”和“羽绒枕”的详细信息页面上展示广告。'}
    ],
    servingStatusOption: [
      {id: 'TARGETING_CLAUSE_ARCHIVED', text: '已归档'},
      {id: 'TARGETING_CLAUSE_PAUSED', text: '已暂停'},
      {id: 'TARGETING_CLAUSE_STATUS_LIVE', text: '正在投放'},
      {id: 'TARGETING_CLAUSE_POLICING_SUSPENDED', text: '警务原因关键字暂停'},
      {id: 'CAMPAIGN_OUT_OF_BUDGET', text: '广告活动超出预算'},
      {id: 'PENDING_START_DATE', text: '广告活动未开始'},
      {id: 'AD_GROUP_PAUSED', text: '广告组已暂停'},
      {id: 'AD_GROUP_ARCHIVED', text: '广告组已归档'},
      {id: 'CAMPAIGN_STATUS_ENABLED', text: '正在投放'},
      {id: 'CAMPAIGN_PAUSED', text: '广告活动已暂停'},
      {id: 'CAMPAIGN_ARCHIVED', text: '广告活动已归档'},
      {id: 'ACCOUNT_OUT_OF_BUDGET', text: '预算外的帐户'},
    ]
  }
};

export const AdProductTargetEnum = {
  SP: {
    status: AdStatus,
    statusOption: AdStatusOption,
    servingStatusOption: [
      {id: 'TARGETING_CLAUSE_ARCHIVED', text: '已归档'},
      {id: 'TARGETING_CLAUSE_PAUSED', text: '已暂停'},
      {id: 'TARGETING_CLAUSE_STATUS_LIVE', text: '正在投放'},
      {id: 'TARGETING_CLAUSE_POLICING_SUSPENDED', text: '警务原因关键字暂停'},
      {id: 'CAMPAIGN_OUT_OF_BUDGET', text: '广告活动超出预算'},
      {id: 'PENDING_START_DATE', text: '广告活动未开始'},
      {id: 'AD_GROUP_PAUSED', text: '广告组已暂停'},
      {id: 'AD_GROUP_ARCHIVED', text: '广告组已归档'},
      {id: 'CAMPAIGN_STATUS_ENABLED', text: '正在投放'},
      {id: 'CAMPAIGN_PAUSED', text: '广告活动已暂停'},
      {id: 'CAMPAIGN_ARCHIVED', text: '广告活动已归档'},
      {id: 'ACCOUNT_OUT_OF_BUDGET', text: '预算外的帐户'},
    ]
  },
  SD: {
    status: AdStatus,
    statusOption: AdStatusOption,
    servingStatusOption: [
      {id: 'TARGETING_CLAUSE_ARCHIVED', text: '已归档'},
      {id: 'TARGETING_CLAUSE_PAUSED', text: '已暂停'},
      {id: 'TARGETING_CLAUSE_STATUS_LIVE', text: '正在投放'},
      {id: 'TARGETING_CLAUSE_POLICING_SUSPENDED', text: '警务原因关键字暂停'},
      {id: 'CAMPAIGN_OUT_OF_BUDGET', text: '广告活动超出预算'},
      {id: 'PENDING_START_DATE', text: '广告活动未开始'},
      {id: 'CAMPAIGN_STATUS_ENABLED', text: '正在投放'},
      {id: 'AD_GROUP_PAUSED', text: '广告组已暂停'},
      {id: 'AD_GROUP_ARCHIVED', text: '广告组已归档'},
      {id: 'CAMPAIGN_PAUSED', text: '广告活动已暂停'},
      {id: 'CAMPAIGN_ARCHIVED', text: '广告活动已归档'},
      {id: 'ACCOUNT_OUT_OF_BUDGET', text: '预算外的帐户'},
    ]
  }
};

export const AdNegKeywordEnum = {
  SP: {
    status: negStatus,
    statusOption: negStatusOption,
    matchType: {
      NEGATIVE_EXACT: 0,
      NEGATIVE_PHRASE: 1
    },
    matchTypeOption: [
      { id: 0, text: '否定精确', color: tagColors.blue.color},
      { id: 1, text: '否定词组', color: tagColors.orange.color},
    ],
    dimension: {
      CAMPAIGN: 0,
      GROUP: 1
    },
    dimensionOption: [
      {id: 0, text: '广告活动'},
      {id: 1, text: '广告组'}
    ],
    servingStatusOption: [

    ]
  },
  SB: {
    status: negStatus,
    statusOption: negStatusOption,
    matchType: {
      NEGATIVE_EXACT: 0,
      NEGATIVE_PHRASE: 1
    },
    matchTypeOption: [
      { id: 0, text: '否定精确', color: tagColors.blue.color },
      { id: 1, text: '否定词组', color: tagColors.orange.color },
    ],
    dimension: {
      CAMPAIGN: 0,
      GROUP: 1
    },
    dimensionOption: [
      {id: 0, text: '广告活动'},
      {id: 1, text: '广告组'}
    ],
    servingStatusOption: [

    ]
  }
};

export const AdNegTargetEnum = {
  SP: {
    status: negStatus,
    statusOption: negStatusOption,
    servingStatusOption: [

    ]
  },
  SD: {
    status: negStatus,
    statusOption: negStatusOption,
  }
};

export const AdPlacementEnum = {
  SP: {
    type: {
      placementProductPage: 'Detail Page on-Amazon',
      placementTop: 'Top of Search on-Amazon',
      Other: 'Other on-Amazon'
    },
    placementOption: [
      {id: 'Detail Page on-Amazon', text: '商品页面', realId: 'placementProductPage'},
      {id: 'Top of Search on-Amazon', text: '搜索结果顶部（首页）', realId: 'placementTop'},
      {id: 'Other on-Amazon', text: '搜索结果的其余位置', realId: 'Other'},
    ],
    strategyPlacementOption: [
      {id: 'placementProductPage', text: '商品页面'},
      {id: 'placementTop', text: '搜索结果顶部（首页）'},
    ],
    placementAliasOption: [
      {id: 'Detail Page on-Amazon', text: '商品页面'},
      {id: 'Top of Search on-Amazon', text: '搜索结果顶部（首页）'},
      {id: 'Other on-Amazon', text: '搜索结果的其余位置'},
    ],
    bidStrategyOption: [
      {id: 0, text: '动态竞价-只降低'},
      {id: 1, text: '动态竞价-提高和降低'},
      {id: 2, text: '固定竞价'},
    ]
  }
};

export const AdSearchWordEnum = {
  SP: {
    effectivenessTypeOption: [
      {id: 0, text: '普通词'},
      {id: 1, text: '高效词'},
      {id: 2, text: '低效词'}
    ]
  }
};

export const AdBidTypeEnum = {
  default: 0,
  targetGroup: 1
};

export const AdTargetTypeEnum = {
  keyword: '1',
  product: '2'
};

export const AdBidStrategyTypeEnum = {
  legacyForSales: 'legacyForSales',
  autoForSales: 'autoForSales',
  manual: 'manual',
};
